import PlacesCreation from './places_creation.coffee'

$(document).on('turbolinks:load', function() {
  if($('.breadcrumb-new')[1]) {
    $('.breadcrumb-new')[1].remove()
  }

  new PlacesCreation().handler_events()
})